'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('./utils');

var _immutableOps = require('immutable-ops');

var _immutableOps2 = _interopRequireDefault(_immutableOps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalOps = (0, _immutableOps2.default)();

/**
 * Handles the underlying data structure for a {@link Model} class.
 */
var Backend = function () {
    /**
     * Creates a new {@link Backend} instance.
     * @param  {Object} userOpts - options to use.
     * @param  {string} [userOpts.idAttribute=id] - the id attribute of the entity.
     * @param  {string} [userOpts.arrName=items] - the state attribute where an array of
     *                                             entity id's are stored
     * @param  {string} [userOpts.mapName=itemsById] - the state attribute where the entity objects
     *                                                 are stored in a id to entity object
     *                                                 map.
     * @param  {Boolean} [userOpts.withMutations=false] - a boolean indicating if the backend
     *                                                    operations should be executed
     *                                                    with or without mutations.
     */

    function Backend(userOpts) {
        (0, _classCallCheck3.default)(this, Backend);

        var defaultOpts = {
            idAttribute: 'id',
            arrName: 'items',
            mapName: 'itemsById',
            withMutations: false
        };

        (0, _assign2.default)(this, defaultOpts, userOpts);
    }

    /**
     * Returns a reference to the object at index `id`
     * in state `branch`.
     *
     * @param  {Object} branch - the state
     * @param  {Number} id - the id of the object to get
     * @return {Object|undefined} A reference to the raw object in the state or
     *                            `undefined` if not found.
     */


    (0, _createClass3.default)(Backend, [{
        key: 'accessId',
        value: function accessId(branch, id) {
            return branch[this.mapName][id];
        }
    }, {
        key: 'accessIdList',
        value: function accessIdList(branch) {
            return branch[this.arrName];
        }
    }, {
        key: 'getOps',
        value: function getOps(tx) {
            if (!tx) {
                return globalOps;
            }
            if (!tx.meta.hasOwnProperty('ops')) {
                tx.meta.ops = (0, _immutableOps2.default)();
                tx.meta.ops.open();
                tx.onClose(function (_tx) {
                    _tx.meta.ops.close();
                });
            }
            return tx.meta.ops;
        }

        /**
         * Returns a {@link ListIterator} instance for
         * the list of objects in `branch`.
         *
         * @param  {Object} branch - the model's state branch
         * @return {ListIterator} An iterator that loops through the objects in `branch`
         */

    }, {
        key: 'iterator',
        value: function iterator(branch) {
            var _this = this;

            return new _utils.ListIterator(branch[this.arrName], 0, function (list, idx) {
                return branch[_this.mapName][list[idx]];
            });
        }
    }, {
        key: 'accessList',
        value: function accessList(branch) {
            var _this2 = this;

            return branch[this.arrName].map(function (id) {
                var obj = _this2.accessId(branch, id);
                return (0, _assign2.default)((0, _defineProperty3.default)({}, _this2.idAttribute, id), obj);
            });
        }

        /**
         * Returns the default state for the data structure.
         * @return {Object} The default state for this {@link Backend} instance's data structure
         */

    }, {
        key: 'getDefaultState',
        value: function getDefaultState() {
            var _ref;

            return _ref = {}, (0, _defineProperty3.default)(_ref, this.arrName, []), (0, _defineProperty3.default)(_ref, this.mapName, {}), _ref;
        }

        /**
         * Returns the data structure including a new object `entry`
         * @param  {Object} session - the current Session instance
         * @param  {Object} branch - the data structure state
         * @param  {Object} entry - the object to insert
         * @return {Object} the data structure including `entry`.
         */

    }, {
        key: 'insert',
        value: function insert(tx, branch, entry) {
            var _ops$merge2;

            var ops = this.getOps(tx);
            var id = entry[this.idAttribute];

            if (this.withMutations) {
                ops.mutable.push(id, branch[this.arrName]);
                ops.mutable.set(id, entry, branch[this.mapName]);
                return branch;
            }

            return ops.merge((_ops$merge2 = {}, (0, _defineProperty3.default)(_ops$merge2, this.arrName, ops.push(id, branch[this.arrName])), (0, _defineProperty3.default)(_ops$merge2, this.mapName, ops.merge((0, _defineProperty3.default)({}, id, entry), branch[this.mapName])), _ops$merge2), branch);
        }

        /**
         * Returns the data structure with objects where id in `idArr`
         * are merged with `mergeObj`.
         *
         * @param  {Object} session - the current Session instance
         * @param  {Object} branch - the data structure state
         * @param  {Array} idArr - the id's of the objects to update
         * @param  {Object} mergeObj - The object to merge with objects
         *                             where their id is in `idArr`.
         * @return {Object} the data structure with objects with their id in `idArr` updated with `mergeObj`.
         */

    }, {
        key: 'update',
        value: function update(tx, branch, idArr, mergeObj) {
            var _this3 = this;

            var ops = this.getOps(tx);

            var mapName = this.mapName;


            var mapFunction = function mapFunction(entity) {
                var merge = _this3.withMutations ? ops.mutable.merge : ops.merge;
                return merge(mergeObj, entity);
            };

            var set = this.withMutations ? ops.mutable.set : ops.set;

            var newMap = idArr.reduce(function (map, id) {
                var result = mapFunction(branch[mapName][id]);
                return set(id, result, map);
            }, branch[mapName]);
            return ops.set(mapName, newMap, branch);
        }

        /**
         * Returns the data structure without objects with their id included in `idsToDelete`.
         * @param  {Object} session - the current Session instance
         * @param  {Object} branch - the data structure state
         * @param  {Array} idsToDelete - the ids to delete from the data structure
         * @return {Object} the data structure without ids in `idsToDelete`.
         */

    }, {
        key: 'delete',
        value: function _delete(tx, branch, idsToDelete) {
            var _ops$merge3;

            var ops = this.getOps(tx);

            var arrName = this.arrName;
            var mapName = this.mapName;

            var arr = branch[arrName];

            if (this.withMutations) {
                idsToDelete.forEach(function (id) {
                    var idx = arr.indexOf(id);
                    if (idx !== -1) {
                        ops.mutable.splice(idx, 1, [], arr);
                    }
                    ops.mutable.omit(id, branch[mapName]);
                });
                return branch;
            }

            return ops.merge((_ops$merge3 = {}, (0, _defineProperty3.default)(_ops$merge3, arrName, ops.filter(function (id) {
                return !(0, _utils.includes)(idsToDelete, id);
            }, branch[arrName])), (0, _defineProperty3.default)(_ops$merge3, mapName, ops.omit(idsToDelete, branch[mapName])), _ops$merge3), branch);
        }
    }]);
    return Backend;
}();

exports.default = Backend;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-orm/lib/Backend.js
 ** module id = 525
 ** module chunks = 0
 **/